export default __webpack_public_path__ + "assets/94ff0218e39d43058abdfb930e64dc4f.svg";